import React, { useState } from 'react'
import {createAuthUserWithEmailAndPassword, createUserDocumentFromAuth} from '../../utils/firebase/firebase.utils';
import FormInput from "../form-input/form-input.component";
import './sign-up-form.styles.scss'
import Button from "../button-component/button-component";

const defaultFormFields = {
    displayName: '',
    email: '',
    password: '',
    confirmPassword: ''
}

const SignUpForm = () => {

    const [formFields, setFormFields] = useState(defaultFormFields);
    const {displayName, email, password, confirmPassword} = formFields;

    const resetFormFields = () => {
        setFormFields(defaultFormFields);
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (password !== confirmPassword) {
            alert('Passwords do not match');
            return;
        }

        try {
            const { user } = await createAuthUserWithEmailAndPassword(email, password);

            await createUserDocumentFromAuth(user, { displayName });
            resetFormFields();
        }
        catch (error) {
            if (error.code === 'auth/email-already-in-use') {
                alert('Cannot create user, email already in use');
            } else if (error.code === 'auth/weak-password') {
                alert('The provided value for the password user property is invalid. It must be a string with at least six characters.');
            }
            else {
                console.log("User creation error", error.message);
            }
        }
    }

    const handleChange = (event) => {
        const {name, value} = event.target;

        setFormFields({...formFields, [name]: value})
    }

    return (
        <div className="sign-up-container">
            <h2>
                Don't have an account?
            </h2>
            <span>Sign up with your email and password</span>
            <form onSubmit={handleSubmit}>
                <FormInput label="Display Name" onChange={handleChange} name="displayName" type="text" required
                           value={displayName}/>

                <FormInput label="Email" onChange={handleChange} name="email" type="email" required value={email}/>

                <FormInput label="Password" onChange={handleChange} name="password" type="password" required
                           value={password}/>

                <FormInput label="Confirm Password" onChange={handleChange} name="confirmPassword" type="password"
                           required value={confirmPassword}/>

                <Button type="submit">Sign Up</Button>
            </form>
        </div>
    )
}
export default SignUpForm
